<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { StepperTitleProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { StepperTitle, useForwardProps } from 'reka-ui'
import { cn } from '@ds/lib/utils'

/*
 * Renders an `<h4>` by default (Reka's `as`), which is right for a handful of
 * steps and wrong for a long rail — pass `as="span"` there rather than leaving
 * a heading per step in the outline.
 */
const props = defineProps<StepperTitleProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <StepperTitle
    v-bind="forwarded"
    :class="cn(
      // The registry ships `text-md`, which is not a Tailwind size at all, so
      // the title silently inherited its parent. Fixed to the scale.
      'font-ds text-sm font-bold whitespace-nowrap',
      props.class,
    )"
  >
    <slot />
  </StepperTitle>
</template>
